export default __webpack_public_path__ + "static/char-52-24edc63e9e3b09bb263f25f77ede9d9f.webp";